<template>
  <Main>
    <ToolsPanel
      :breadCrumbFirst="$t('nav.integrations')"
      :breadCrumbFirstLink="getFirstLink"
      :breadCrumbSecond="$t('integration.editBreadcrumb')"
      :title="$t('integration.editBreadcrumb')"
    >
      <div class="form-create__buttons">
        <MainButton buttonWhite @click.native="handleSubmit">Submit</MainButton>
        <MainButton @click.native="handleBackToList">Back</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="form-create">
        <form @submit.prevent="handleSubmit">
          <p class="form-create__label">Name</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'name'"
              :label="'name'"
              :type="'text'"
              :placeholder="'name'"
              :error-messages="validationErrors['name']"
              isBordered
            />
          </div>

          <p class="form-create__label">API url</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'api_url'"
              :label="'api_url'"
              :type="'text'"
              :placeholder="'api url'"
              :error-messages="validationErrors['apiUrl']"
              isBordered
            />
          </div>

          <p class="form-create__label">API key</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'api_key'"
              :label="'api_key'"
              :type="'text'"
              :placeholder="'api key'"
              :error-messages="validationErrors['apiKey']"
              isBordered
            />
          </div>

          <p class="form-create__label">Map ID</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'map_id'"
              :label="'map_id'"
              :type="'text'"
              :placeholder="'map id'"
              :error-messages="validationErrors['mapId']"
              isBordered
            />
          </div>

          <p class="form-create__label">Send Frequency</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'send_frequency'"
              :label="'send_frequency'"
              :type="'text'"
              :placeholder="'send frequency'"
              :error-messages="validationErrors['sendFrequency']"
              isBordered
            />
          </div>

          <p class="form-create__label">Send Capacity</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'send_capacity'"
              :label="'send_capacity'"
              :type="'text'"
              :placeholder="'send capacity'"
              :error-messages="validationErrors['sendCapacity']"
              isBordered
            />
          </div>

          <p class="form-create__label">Send Capacity Duplicate</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'send_capacity_duplicate'"
              :label="'send_capacity_duplicate'"
              :type="'number'"
              :placeholder="'send capacity duplicate'"
              :error-messages="validationErrors['sendCapacityDuplicate']"
              isBordered
            />
          </div>

          <p class="form-create__label">Lead Fresh Time</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'lead_fresh_time'"
              :label="'lead_fresh_time'"
              :type="'text'"
              :placeholder="'lead fresh time'"
              :error-messages="validationErrors['leadFreshTime']"
              isBordered
            />
          </div>

          <p class="form-create__label">Campaign Include Rule</p>

          <MainButton class="fit" @click.native="addInput('campaign_include_rule')"
            >Add Field</MainButton
          >
          <div
            v-for="(item, index) in formDataToSend.campaign_include_rule"
            class="input-container multi-field"
            :key="`1_${index}`"
          >
            <input
              class="multi-field__input"
              type="text"
              v-model="formDataToSend.campaign_include_rule[index]"
            />
            <div @click="deleteInput('campaign_include_rule', index)" class="multi-field__delete">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
                width="20px"
                height="20px"
                viewBox="0 -5 32 32"
                version="1.1"
              >
                <defs></defs>
                <g
                  id="Page-1"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                  sketch:type="MSPage"
                >
                  <g
                    id="Icon-Set-Filled"
                    sketch:type="MSLayerGroup"
                    transform="translate(-518.000000, -1146.000000)"
                    fill="#000000"
                  >
                    <path
                      d="M540.647,1159.24 C541.039,1159.63 541.039,1160.27 540.647,1160.66 C540.257,1161.05 539.623,1161.05 539.232,1160.66 L536.993,1158.42 L534.725,1160.69 C534.331,1161.08 533.692,1161.08 533.298,1160.69 C532.904,1160.29 532.904,1159.65 533.298,1159.26 L535.566,1156.99 L533.327,1154.76 C532.936,1154.37 532.936,1153.73 533.327,1153.34 C533.718,1152.95 534.352,1152.95 534.742,1153.34 L536.981,1155.58 L539.281,1153.28 C539.676,1152.89 540.314,1152.89 540.708,1153.28 C541.103,1153.68 541.103,1154.31 540.708,1154.71 L538.408,1157.01 L540.647,1159.24 L540.647,1159.24 Z M545.996,1146 L528.051,1146 C527.771,1145.98 527.485,1146.07 527.271,1146.28 L518.285,1156.22 C518.074,1156.43 517.983,1156.71 517.998,1156.98 C517.983,1157.26 518.074,1157.54 518.285,1157.75 L527.271,1167.69 C527.467,1167.88 527.723,1167.98 527.979,1167.98 L527.979,1168 L545.996,1168 C548.207,1168 550,1166.21 550,1164 L550,1150 C550,1147.79 548.207,1146 545.996,1146 L545.996,1146 Z"
                      id="delete"
                      sketch:type="MSShapeGroup"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
          </div>

          <p class="form-create__label">Campaign Exclude Rule</p>

          <MainButton class="fit" @click.native="addInput('campaign_exclude_rule')"
            >Add Field</MainButton
          >
          <div
            v-for="(item, index) in formDataToSend.campaign_exclude_rule"
            class="input-container multi-field"
            :key="`2_${index}`"
          >
            <input
              class="multi-field__input"
              type="text"
              v-model="formDataToSend.campaign_exclude_rule[index]"
            />
            <div @click="deleteInput('campaign_exclude_rule', index)" class="multi-field__delete">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
                width="20px"
                height="20px"
                viewBox="0 -5 32 32"
                version="1.1"
              >
                <defs></defs>
                <g
                  id="Page-1"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                  sketch:type="MSPage"
                >
                  <g
                    id="Icon-Set-Filled"
                    sketch:type="MSLayerGroup"
                    transform="translate(-518.000000, -1146.000000)"
                    fill="#000000"
                  >
                    <path
                      d="M540.647,1159.24 C541.039,1159.63 541.039,1160.27 540.647,1160.66 C540.257,1161.05 539.623,1161.05 539.232,1160.66 L536.993,1158.42 L534.725,1160.69 C534.331,1161.08 533.692,1161.08 533.298,1160.69 C532.904,1160.29 532.904,1159.65 533.298,1159.26 L535.566,1156.99 L533.327,1154.76 C532.936,1154.37 532.936,1153.73 533.327,1153.34 C533.718,1152.95 534.352,1152.95 534.742,1153.34 L536.981,1155.58 L539.281,1153.28 C539.676,1152.89 540.314,1152.89 540.708,1153.28 C541.103,1153.68 541.103,1154.31 540.708,1154.71 L538.408,1157.01 L540.647,1159.24 L540.647,1159.24 Z M545.996,1146 L528.051,1146 C527.771,1145.98 527.485,1146.07 527.271,1146.28 L518.285,1156.22 C518.074,1156.43 517.983,1156.71 517.998,1156.98 C517.983,1157.26 518.074,1157.54 518.285,1157.75 L527.271,1167.69 C527.467,1167.88 527.723,1167.98 527.979,1167.98 L527.979,1168 L545.996,1168 C548.207,1168 550,1166.21 550,1164 L550,1150 C550,1147.79 548.207,1146 545.996,1146 L545.996,1146 Z"
                      id="delete"
                      sketch:type="MSShapeGroup"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
          </div>

          <p class="form-create__label">Country Capacities</p>

          <MainButton class="form-create__add" @click.native="addInputCap()">
            Add Country Capacities
          </MainButton>

          <div
            v-for="(item, index) in formDataToSend.country_capacities"
            class="input-container multi-field"
            :key="`3_${index}`"
          >
            <div class="multi-field__text">
              {{ formDataToSend.country_capacities[index].country_name }}
            </div>
            <div class="multi-field__container">
              <input
                class="multi-field__input"
                type="text"
                placeholder="percent"
                v-model="formDataToSend.country_capacities[index].percent"
              />
            </div>
            <div @click="deleteInputCap(index)" class="multi-field__delete">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
                width="20px"
                height="20px"
                viewBox="0 -5 32 32"
                version="1.1"
              >
                <defs></defs>
                <g
                  id="Page-1"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                  sketch:type="MSPage"
                >
                  <g
                    id="Icon-Set-Filled"
                    sketch:type="MSLayerGroup"
                    transform="translate(-518.000000, -1146.000000)"
                    fill="#000000"
                  >
                    <path
                      d="M540.647,1159.24 C541.039,1159.63 541.039,1160.27 540.647,1160.66 C540.257,1161.05 539.623,1161.05 539.232,1160.66 L536.993,1158.42 L534.725,1160.69 C534.331,1161.08 533.692,1161.08 533.298,1160.69 C532.904,1160.29 532.904,1159.65 533.298,1159.26 L535.566,1156.99 L533.327,1154.76 C532.936,1154.37 532.936,1153.73 533.327,1153.34 C533.718,1152.95 534.352,1152.95 534.742,1153.34 L536.981,1155.58 L539.281,1153.28 C539.676,1152.89 540.314,1152.89 540.708,1153.28 C541.103,1153.68 541.103,1154.31 540.708,1154.71 L538.408,1157.01 L540.647,1159.24 L540.647,1159.24 Z M545.996,1146 L528.051,1146 C527.771,1145.98 527.485,1146.07 527.271,1146.28 L518.285,1156.22 C518.074,1156.43 517.983,1156.71 517.998,1156.98 C517.983,1157.26 518.074,1157.54 518.285,1157.75 L527.271,1167.69 C527.467,1167.88 527.723,1167.98 527.979,1167.98 L527.979,1168 L545.996,1168 C548.207,1168 550,1166.21 550,1164 L550,1150 C550,1147.79 548.207,1146 545.996,1146 L545.996,1146 Z"
                      id="delete"
                      sketch:type="MSShapeGroup"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
          </div>

          <p class="form-create__label">Client</p>
          <div class="input-container">
            <MainSelect
              :id="'client'"
              :placeholder="'Client'"
              :option-list="clientList"
              :set-value="formDataToSend"
              :value="formDataToSend.client"
              :labelName="'name'"
            />
          </div>

          <template v-if="countryArray.length > 0">
            <p class="form-create__label">Country</p>
            <div :class="['form-create__chosen-check blur']">
              <div
                v-for="(item, index) in Object.keys(formDataToSend.country_ids)"
                :key="`4_${index}`"
              >
                <div v-if="formDataToSend.country_ids[item]" class="form-create__chosen-check-item">
                  {{
                    countryArray.find((country) => {
                      return country.id == item;
                    }).enName
                  }}

                  <div @click="handleUncheckCountry(item)" class="form-create__chosen-check-close">
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.1211 3.48832C13.2192 -0.412773 6.87359 -0.412773 2.97168 3.48832C-0.928549 7.38941 -0.928549 13.7367 2.97168 17.6377C4.92264 19.5879 7.48471 20.5625 10.0468 20.5625C12.6089 20.5625 15.1702 19.5878 17.1211 17.6377C21.0222 13.7367 21.0222 7.38941 17.1211 3.48832ZM14.173 13.5107C14.499 13.8367 14.499 14.3636 14.173 14.6896C14.0104 14.8522 13.797 14.9339 13.5835 14.9339C13.3701 14.9339 13.1566 14.8522 12.9941 14.6896L10.0468 11.7415L7.10034 14.6888C6.93694 14.8513 6.72348 14.9331 6.51088 14.9331C6.29745 14.9331 6.08399 14.8513 5.92141 14.6888C5.59543 14.3628 5.59543 13.835 5.92141 13.5099L8.86785 10.5626L5.92059 7.61534C5.59461 7.28936 5.59461 6.7616 5.92059 6.43644C6.24575 6.11046 6.7735 6.11046 7.09948 6.43644L10.0467 9.38371L12.994 6.43644C13.32 6.11046 13.8469 6.11046 14.1729 6.43644C14.4989 6.7616 14.4989 7.28936 14.1729 7.61534L11.2256 10.5626L14.173 13.5107Z"
                        fill="#2F2F34"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-create__chosen-check">
              <div @click="allCountryChoose(true)" class="form-create__chosen-check-item button">
                Select All
              </div>
              <div @click="allCountryChoose(false)" class="form-create__chosen-check-item button">
                Deselect All
              </div>
            </div>

            <input
              type="text"
              placeholder="Search..."
              v-model="countrySearch"
              class="form-create__category-search"
              @input="filterCountry"
            />

            <div v-if="countrySearch.length > 0" class="input-container checkbox-container">
              <div
                v-for="item in countryArrayFilter"
                :key="item.id"
                class="checkbox-container__item"
              >
                <MainCheckbox
                  :label="item.enName"
                  :id="item.id + ''"
                  :set-value="formDataToSend.country_ids"
                />
              </div>
            </div>

            <div v-if="countrySearch.length == 0" class="input-container checkbox-container">
              <div v-for="item in countryArray" :key="item.id" class="checkbox-container__item">
                <MainCheckbox
                  :label="item.enName"
                  :id="item.id + ''"
                  :set-value="formDataToSend.country_ids"
                />
              </div>
            </div>
          </template>
          <Notification :error-messages="validationErrors['countryIds']" />

          <template v-if="userArray.length > 0">
            <p class="form-create__label">User (Affiliate Manager)</p>
            <div :class="['form-create__chosen-check blur']">
              <div
                v-for="(item, index) in Object.keys(formDataToSend.user_ids)"
                :key="`4_${index}`"
              >
                <div v-if="formDataToSend.user_ids[item]" class="form-create__chosen-check-item">
                  {{
                    userArray.find((user) => {
                      return user.id == item;
                    })?.name
                  }}

                  <div @click="handleUncheckUser(item)" class="form-create__chosen-check-close">
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.1211 3.48832C13.2192 -0.412773 6.87359 -0.412773 2.97168 3.48832C-0.928549 7.38941 -0.928549 13.7367 2.97168 17.6377C4.92264 19.5879 7.48471 20.5625 10.0468 20.5625C12.6089 20.5625 15.1702 19.5878 17.1211 17.6377C21.0222 13.7367 21.0222 7.38941 17.1211 3.48832ZM14.173 13.5107C14.499 13.8367 14.499 14.3636 14.173 14.6896C14.0104 14.8522 13.797 14.9339 13.5835 14.9339C13.3701 14.9339 13.1566 14.8522 12.9941 14.6896L10.0468 11.7415L7.10034 14.6888C6.93694 14.8513 6.72348 14.9331 6.51088 14.9331C6.29745 14.9331 6.08399 14.8513 5.92141 14.6888C5.59543 14.3628 5.59543 13.835 5.92141 13.5099L8.86785 10.5626L5.92059 7.61534C5.59461 7.28936 5.59461 6.7616 5.92059 6.43644C6.24575 6.11046 6.7735 6.11046 7.09948 6.43644L10.0467 9.38371L12.994 6.43644C13.32 6.11046 13.8469 6.11046 14.1729 6.43644C14.4989 6.7616 14.4989 7.28936 14.1729 7.61534L11.2256 10.5626L14.173 13.5107Z"
                        fill="#2F2F34"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-create__chosen-check">
              <div @click="allUserChoose(true)" class="form-create__chosen-check-item button">
                Select All
              </div>
              <div @click="allUserChoose(false)" class="form-create__chosen-check-item button">
                Deselect All
              </div>
            </div>

            <input
              type="text"
              placeholder="Search..."
              v-model="userSearch"
              class="form-create__category-search"
              @input="filterUser"
            />

            <div v-if="userSearch.length > 0" class="input-container checkbox-container">
              <div v-for="item in userArrayFilter" :key="item.id" class="checkbox-container__item">
                <MainCheckbox
                  :label="item.name"
                  :id="item.id + ''"
                  :set-value="formDataToSend.user_ids"
                />
              </div>
            </div>

            <div v-if="userSearch.length == 0" class="input-container checkbox-container">
              <div v-for="item in userArray" :key="item.id" class="checkbox-container__item">
                <MainCheckbox
                  :label="item.name"
                  :id="item.id + ''"
                  :set-value="formDataToSend.user_ids"
                />
              </div>
            </div>
          </template>
          <Notification :error-messages="validationErrors['userIds']" />

          <p class="form-create__label">Language</p>

          <div class="input-container checkbox-container checkbox-container_margin">
            <div class="checkbox-container__item">
              <InputRadio
                :set-value="formDataToSend"
                :id="'language_id'"
                :values="languageArray"
                :name="'code'"
                :value="'id'"
              />
            </div>
          </div>
          <Notification :error-messages="validationErrors['languageIds']" />

          <p class="form-create__label">Send Work Time</p>

          <div class="time__toggle-container">
            <div
              @click="toggleWorkTime('all')"
              :class="[
                'time__toggle-item',
                formDataToSend.send_work_time.all.length > 0 && 'active',
              ]"
            >
              All day
            </div>
            <div
              @click="toggleWorkTime('away')"
              :class="[
                'time__toggle-item',
                formDataToSend.send_work_time.all.length == 0 && 'active',
              ]"
            >
              Different
            </div>
          </div>

          <div v-if="formDataToSend.send_work_time.all.length > 0" class="time__item">
            <time-picker
              v-model="formDataToSend.send_work_time.all[0]"
              format="HH:mm"
              :minute-interval="5"
            ></time-picker>
            -
            <time-picker
              v-model="formDataToSend.send_work_time.all[1]"
              format="HH:mm"
              :minute-interval="5"
            ></time-picker>
          </div>

          <div v-if="formDataToSend.send_work_time.all.length == 0" class="time__item">
            <div
              v-for="(day, index) in Object.keys(formDataToSend.send_work_time.days)"
              :key="`5_${index}`"
              class="time__item-day"
            >
              <div class="time__item-day-name">{{ day }}</div>
              <time-picker
                v-model="formDataToSend.send_work_time.days[day][0]"
                format="HH:mm"
                :minute-interval="5"
              ></time-picker>
              <div class="time__item-day-line">-</div>
              <time-picker
                v-model="formDataToSend.send_work_time.days[day][1]"
                format="HH:mm"
                :minute-interval="5"
              ></time-picker>
            </div>
          </div>

          <Notification :error-messages="validationErrors['sendWorkTime']" />

          <p class="form-create__label">Type Integration</p>

          <div class="input-container checkbox-container checkbox-container_margin">
            <div class="checkbox-container__item">
              <InputRadio
                :set-value="formDataToSend"
                :id="'type_id'"
                :values="integrationTypeList"
                :name="'name'"
                :value="'id'"
              />
            </div>
          </div>

          <Notification :error-messages="validationErrors['typeId']" />

          <p class="form-create__label">{{ $t("integration.costType") }}</p>

          <div class="input-container checkbox-container checkbox-container_margin">
            <div class="checkbox-container__item">
              <InputRadio
                :set-value="formDataToSend"
                :id="'cost_type'"
                :values="costTypeList"
                :name="'name'"
                :value="'id'"
              />
            </div>
          </div>

          <Notification :error-messages="validationErrors['costType']" />

          <p class="form-create__label">Integration Type</p>

          <div class="input-container checkbox-container checkbox-container_margin">
            <div class="checkbox-container__item">
              <InputRadio
                :set-value="formDataToSend"
                :id="'integration_type'"
                :values="integrationSpecialTypeList"
                :name="'name'"
                :value="'id'"
              />
            </div>
          </div>

          <Notification :error-messages="validationErrors['integrationType']" />

          <div class="input-container">
            <MainCheckbox :label="'Active'" :id="'is_active'" :set-value="formDataToSend" />
          </div>

          <div class="input-container">
            <MainCheckbox
              :label="'Have deposit'"
              :id="'is_have_deposit'"
              :set-value="formDataToSend"
            />
          </div>

          <div class="input-container">
            <ValidStatusesField v-model="formDataToSend.valid_statuses" :integration-id="getId" />
            <Notification :error-messages="validationErrors['validStatuses']" />
          </div>

          <div class="input-container">
            <TeamQuotasField
              ref="teamQuotas"
              :integration-id="getId"
              :send-capacity="formDataToSend.send_capacity"
            />
          </div>

          <div class="input-container">
            <MainCheckbox
              :label="'Unique emails'"
              :id="'is_unique_emails'"
              :set-value="formDataToSend"
            />
          </div>

          <div class="input-container">
            <MainCheckbox
              :label="'Reset Integrations'"
              :id="'is_reset_integrations'"
              :set-value="formDataToSend"
            />
          </div>

          <div v-if="error.message != undefined" class="form-create__error">
            {{ error.message }}
          </div>
          <div class="form-create__btn">
            <MainButton :type="'submit'">Submit</MainButton>
          </div>
        </form>
        <MainModal v-if="countryModal" :on-close="handleCountryModal" :modal-center="true">
          <div class="list__confirm">
            <div class="list__confirm-column">
              <div class="list__confirm-title">Choose Country</div>
              <div>
                <div class="multi-field__search">
                  <input v-model="searchCountry" type="text" placeholder="search country" />
                </div>
                <div class="input-container checkbox-container checkbox-container_margin">
                  <div class="checkbox-container__item">
                    <InputRadio
                      :set-value="chosen"
                      :id="'country_id'"
                      :values="getCheckList('countryArray', 'searchCountry', 'enName')"
                      :name="'enName'"
                      :value="'id'"
                    />
                  </div>
                </div>
              </div>
              <div class="list__confirm-buttons">
                <div class="list__confirm-button">
                  <MainButton buttonWhite @click.native="handleCountryModal">CANCEL</MainButton>
                </div>
                <div class="list__confirm-button">
                  <MainButton @click.native="handleAddInputCap" :button-cancel="true"
                    >ADD</MainButton
                  >
                </div>
              </div>
            </div>
          </div>
        </MainModal>
        <ModalError
          :error-modal="false"
          :handle-close-error-modal="
            () => {
              this.error = {};
            }
          "
        />
      </div>
    </ContentContainer>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import TimePicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import leadApi from "~/api/lead";
import userApi from "~/api/user";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import InputText from "~/components/atoms/inputs/InputText.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import MainCheckbox from "~/components/atoms/inputs/MainCheckbox.vue";
import InputRadio from "~/components/atoms/inputs/InputRadio.vue";
import Notification from "~/components/molecules/Notification.vue";
import MainSelect from "~/components/atoms/inputs/MainSelect.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ValidStatusesField from "~/components/molecules/ValidStatusesField.vue";
import TeamQuotasField from "~/components/molecules/TeamQuotasField.vue";

export default {
  name: "IntegrationEdit",
  metaInfo: {
    title: "Integration Edit",
  },
  data() {
    return {
      formDataToSend: {
        name: "",
        is_active: true,
        is_have_deposit: false,
        is_unique_emails: false,
        is_reset_integrations: false,
        type_id: null,
        language_id: null,
        cost_type: null,
        integration_type: null,
        client: null,
        send_frequency: "* * * * *",
        send_capacity: "",
        country_ids: {},
        user_ids: {},
        api_key: "",
        api_url: "",
        map_id: "",
        send_capacity_duplicate: "",
        lead_fresh_time: "",
        send_work_time: {
          all: [],
          days: {
            mon: [],
            tue: [],
            wed: [],
            thu: [],
            fri: [],
            sat: [],
            sun: [],
          },
        },
        campaign_include_rule: [],
        campaign_exclude_rule: [],
        country_capacities: [],
        valid_statuses: [],
      },
      chosen: {
        country_id: null,
      },
      countryModal: false,
      searchCountry: "",
      clientList: [],
      integrationTypeList: [],
      userArray: [],
      userArrayFilter: [],
      userSearch: "",
      countryArray: [],
      countryArrayFilter: [],
      countrySearch: "",
      languageArray: [],

      costTypeList: [
        {
          name: this.$t("common.all"),
          id: "all",
        },
        {
          name: "CPL",
          id: "cpl",
        },
        {
          name: "CPA",
          id: "cpa",
        },
      ],

      integrationSpecialTypeList: [
        {
          name: this.$t("common.all"),
          id: "all",
        },
        {
          name: "In",
          id: "in",
        },
        {
          name: "Out",
          id: "out",
        },
      ],
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    InputText,
    ModalError,
    MainCheckbox,
    InputRadio,
    TimePicker,
    Notification,
    MainSelect,
    MainModal,
    ValidStatusesField,
    TeamQuotasField,
  },
  mounted() {
    this.getIntegrationType();
    this.getCountry();
    this.getClient();
    this.getLanguage();
  },
  computed: {
    ...mapState("lead", ["error", "loadingProcess", "validationErrors"]),
    getFirstLink() {
      return ROUTE.INTEGRATION_LIST.replace(":page", 1);
    },
    getId() {
      return this.$route.params.id;
    },
  },
  methods: {
    getItem() {
      const url = `/${this.getId}?with[0]=countries&with[1]=client&with[2]=languages&with[3]=countryCapacities&with[4]=users`;
      try {
        leadApi.getItemIntegration(url).then((res) => {
          this.$store.commit("lead/setError", {});
          this.$store.commit("lead/setValidationErrors", {});
          const data = res.data;
          this.formDataToSend.name = data.name;
          this.formDataToSend.is_active = data.isActive;
          this.formDataToSend.is_have_deposit = data.isHaveDeposit ? true : false;
          this.formDataToSend.is_unique_emails = data.isUniqueEmails;
          this.formDataToSend.is_reset_integrations = data.isResetIntegrations;
          this.formDataToSend.type_id = data.typeId;
          this.formDataToSend.cost_type = data.costType;
          this.formDataToSend.integration_type = data.integrationType;
          this.formDataToSend.send_frequency = data.sendFrequency;
          this.formDataToSend.send_capacity = data.sendCapacity;
          this.formDataToSend.send_capacity_duplicate = data.sendCapacityDuplicate;
          this.formDataToSend.lead_fresh_time = data.leadFreshTime;
          this.formDataToSend.api_key = data.apiKey;
          this.formDataToSend.api_url = data.apiUrl;
          this.formDataToSend.map_id = data.mapId;
          this.formDataToSend.valid_statuses = Array.isArray(data.validStatuses)
            ? data.validStatuses
            : [];

          if (data.countryCapacities.length) {
            data.countryCapacities.forEach((elem) => {
              this.formDataToSend.country_capacities.push({
                country_id: elem.countryId,
                country_name: this.countryArray.find((item) => item.id == elem.countryId).enName,
                percent: elem.percent,
              });
            });
          }

          if (data.campaignIncludeRule && data.campaignIncludeRule.length) {
            this.formDataToSend.campaign_include_rule = data.campaignIncludeRule;
          } else {
            this.formDataToSend.campaign_include_rule = [""];
          }

          if (data.campaignExcludeRule && data.campaignExcludeRule.length) {
            this.formDataToSend.campaign_exclude_rule = data.campaignExcludeRule;
          } else {
            this.formDataToSend.campaign_exclude_rule = [""];
          }

          if (data.clientId) {
            this.formDataToSend.client = data.client;
          }

          if (data.languages.length > 0) {
            this.formDataToSend.language_id = data.languages[0].languageId;
          }

          if (data.sendWorkTime.all) {
            this.formDataToSend.send_work_time.all = data.sendWorkTime.all.split("-").map((t) => {
              const [HH, mm] = t.split(":");
              return { HH, mm };
            });
          } else if (data.sendWorkTime.days) {
            const days = Object.keys(data.sendWorkTime.days);

            for (let i = 0; days.length > i; i++) {
              this.formDataToSend.send_work_time.days[days[i]] = data.sendWorkTime.days[days[i]]
                .split("-")
                .map((t) => {
                  const [HH, mm] = t.split(":");
                  return { HH, mm };
                });
            }
          }

          const country = data.countries;
          if (country != undefined && country.length > 0) {
            for (let i = 0; country.length > i; i++) {
              this.$set(this.formDataToSend.country_ids, country[i].countryId, true);
            }
          }

          const user = data.users;
          if (user != undefined && user.length > 0) {
            for (let i = 0; user.length > i; i++) {
              this.$set(this.formDataToSend.user_ids, user[i].userId, true);
            }
          }

          this.setCountry();
          this.setUser();
        });
      } catch (error) {
        console.log(error);
      }
    },
    handleSubmit() {
      const data = {
        name: this.formDataToSend.name,
        is_active: this.formDataToSend.is_active,
        is_have_deposit: this.formDataToSend.is_have_deposit ? 1 : 0,
        is_unique_emails: this.formDataToSend.is_unique_emails,
        is_reset_integrations: this.formDataToSend.is_reset_integrations,
        type_id: this.formDataToSend.type_id,
        cost_type: this.formDataToSend.cost_type,
        integration_type: this.formDataToSend.integration_type,
        send_frequency: this.formDataToSend.send_frequency,
        send_capacity: this.formDataToSend.send_capacity,
        api_url: this.formDataToSend.api_url,
        api_key: this.formDataToSend.api_key,
        map_id: this.formDataToSend.map_id,
        send_capacity_duplicate: this.formDataToSend.send_capacity_duplicate,
        lead_fresh_time: this.formDataToSend.lead_fresh_time,
        campaign_include_rule: this.formDataToSend.campaign_include_rule,
        campaign_exclude_rule: this.formDataToSend.campaign_exclude_rule,
        valid_statuses: this.formDataToSend.valid_statuses,
      };

      const country_capacities_new = [];
      if (this.formDataToSend.country_capacities.length > 0) {
        this.formDataToSend.country_capacities.forEach((elem, index) => {
          if (elem.country_id) {
            country_capacities_new.push(elem);
          }
        });
      }
      data.country_capacities = country_capacities_new;

      if (this.formDataToSend.language_id) {
        data.language_ids = [this.formDataToSend.language_id];
      } else {
        data.language_ids = [];
      }

      if (this.formDataToSend.client) {
        data.client_id = this.formDataToSend.client.id;
      }

      const key = Object.keys(this.formDataToSend.send_work_time.days);
      data.send_work_time = {};

      if (this.formDataToSend.send_work_time.all.length > 0) {
        data.send_work_time.all = `${this.formDataToSend.send_work_time.all[0].HH}:${this.formDataToSend.send_work_time.all[0].mm}-${this.formDataToSend.send_work_time.all[1].HH}:${this.formDataToSend.send_work_time.all[1].mm}`;
      } else {
        data.send_work_time.days = {};

        for (let i = 0; key.length > i; i++) {
          if (this.formDataToSend.send_work_time.days[key[i]].length == 2) {
            data.send_work_time.days[key[i]] = `${
              this.formDataToSend.send_work_time.days[key[i]][0].HH
            }:${this.formDataToSend.send_work_time.days[key[i]][0].mm}-${
              this.formDataToSend.send_work_time.days[key[i]][1].HH
            }:${this.formDataToSend.send_work_time.days[key[i]][1].mm}`;
          }
        }
      }

      const country = Object.keys(this.formDataToSend.country_ids);
      if (country.length) {
        let countrySend = [];
        for (let i = 0; country.length > i; i++) {
          if (this.formDataToSend.country_ids[country[i]] == true) {
            countrySend.push(+country[i]);
          }
        }
        if (countrySend.length > 0) {
          data.country_ids = countrySend;
        } else {
          data.country_ids = [];
        }
      }

      const user = Object.keys(this.formDataToSend.user_ids);
      if (user.length) {
        let userSend = [];
        for (let i = 0; user.length > i; i++) {
          if (this.formDataToSend.user_ids[user[i]] == true) {
            userSend.push(+user[i]);
          }
        }
        if (userSend.length > 0) {
          data.user_ids = userSend;
        }
      }

      console.log(data);

      const url = `/${this.getId}`;

      this.$store.dispatch("lead/editIntegration", { url: url, editData: data });

      // Квоты команд лежат в своих таблицах и сохраняются отдельным запросом.
      // Без этого доли, выставленные в блоке, терялись при обычном Submit:
      // человек менял капу, жал «Сохранить» и обнаруживал, что 50 на 50 пропало.
      if (this.$refs.teamQuotas) {
        this.$refs.teamQuotas.save();
      }
    },

    async getLanguage() {
      this.languageArray = [];

      await leadApi
        .getLanguageList()
        .then((res) => {
          console.log(res.data.items, "lang");
          this.languageArray = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },

    async getClient() {
      let url = "";
      await leadApi
        .getClientListAll(url)
        .then((res) => {
          this.clientList = res.data;
          console.log(this.clientList);
        })
        .catch((error) => {})
        .finally(() => {});
    },
    handleBackToList() {
      this.$router.push({
        path: ROUTE.INTEGRATION_LIST.replace(":page", 1),
      });
    },
    getIntegrationType() {
      this.$store.commit("lead/setLoading", true);
      leadApi
        .getIntegrationType()
        .then((res) => {
          this.$store.commit("lead/setLoading", false);
          if (res.success) {
            this.integrationTypeList = res.data;
          }
        })
        .catch((error) => {
          this.$store.commit("lead/setLoading", false);
          console.log(error);
        });
    },

    async getCountry() {
      this.countryArray = [];
      this.userArray = [];

      try {
        const [countryRes, userRes] = await Promise.all([
          leadApi.getCountryList(),
          userApi.getUsersAllList(),
        ]);

        this.countryArray = countryRes.data.items;
        this.userArray = userRes.data;
      } catch (error) {
        console.error(error);
      }

      this.getItem();
    },

    setCountry() {
      const country = this.countryArray;
      for (let i = 0; country.length > i; i++) {
        if (this.formDataToSend.country_ids[country[i].id] == undefined) {
          this.$set(this.formDataToSend.country_ids, country[i].id, false);
        }
      }
    },

    setUser() {
      const user = this.userArray;
      for (let i = 0; user.length > i; i++) {
        if (this.formDataToSend.user_ids[user[i].id] == undefined) {
          this.$set(this.formDataToSend.user_ids, user[i].id, false);
        }
      }
    },

    handleUncheckCountry(id) {
      this.formDataToSend.country_ids[id] = false;
    },
    handleUncheckUser(id) {
      this.formDataToSend.user_ids[id] = false;
    },
    toggleWorkTime(type) {
      if (type == "all") {
        this.formDataToSend.send_work_time.days.mon = [];
        this.formDataToSend.send_work_time.days.tue = [];
        this.formDataToSend.send_work_time.days.wed = [];
        this.formDataToSend.send_work_time.days.thu = [];
        this.formDataToSend.send_work_time.days.fri = [];
        this.formDataToSend.send_work_time.days.sat = [];
        this.formDataToSend.send_work_time.days.sun = [];

        this.formDataToSend.send_work_time.all = [
          { HH: "09", mm: "00" },
          { HH: "18", mm: "00" },
        ];
      }

      if (type == "away") {
        this.formDataToSend.send_work_time.all = [];

        this.formDataToSend.send_work_time.days.mon = [
          { HH: "09", mm: "00" },
          { HH: "18", mm: "00" },
        ];
        this.formDataToSend.send_work_time.days.tue = [
          { HH: "09", mm: "00" },
          { HH: "18", mm: "00" },
        ];
        this.formDataToSend.send_work_time.days.wed = [
          { HH: "09", mm: "00" },
          { HH: "18", mm: "00" },
        ];
        this.formDataToSend.send_work_time.days.thu = [
          { HH: "09", mm: "00" },
          { HH: "18", mm: "00" },
        ];
        this.formDataToSend.send_work_time.days.fri = [
          { HH: "09", mm: "00" },
          { HH: "18", mm: "00" },
        ];
      }
    },
    filterCountry() {
      const query = this.countrySearch.toLowerCase();
      this.countryArrayFilter = this.countryArray.filter((item) =>
        item.enName.toLowerCase().includes(query),
      );
    },
    filterUser() {
      const query = this.userSearch.toLowerCase();
      this.userArrayFilter = this.userArray.filter((item) =>
        item.name.toLowerCase().includes(query),
      );
    },
    allCountryChoose(data) {
      Object.keys(this.formDataToSend.country_ids).forEach((key) => {
        this.formDataToSend.country_ids[key] = data;
      });
    },
    allUserChoose(data) {
      Object.keys(this.formDataToSend.user_ids).forEach((key) => {
        this.formDataToSend.user_ids[key] = data;
      });
    },
    deleteInput(name, index) {
      this.formDataToSend[name].splice(index, 1);
    },
    addInput(name) {
      this.formDataToSend[name].push("");
    },
    deleteInputCap(index) {
      this.formDataToSend.country_capacities.splice(index, 1);
    },
    addInputCap() {
      this.countryModal = true;
      this.chosen.country_id = null;
    },
    handleAddInputCap() {
      if (this.chosen.country_id) {
        this.formDataToSend.country_capacities.push({
          country_id: this.chosen.country_id,
          country_name: this.countryArray.find((item) => item.id == this.chosen.country_id).enName,
          percent: "",
        });
        this.handleCountryModal();
      }
    },
    handleCountryModal() {
      this.countryModal = false;
      this.chosen.country_id = null;
    },
    getCheckList(listKey, filterKey, nameKey) {
      const arr = this?.[listKey];
      const rawFilter = this?.[filterKey];

      if (!Array.isArray(arr)) return [];

      if (rawFilter == null || String(rawFilter).trim() === "") return arr;

      const filterStr = String(rawFilter).toLowerCase().trim();

      return arr.filter((item) => {
        const val = item?.[nameKey];
        if (val == null) return false;

        return String(val).toLowerCase().includes(filterStr);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.list__confirm-buttons {
  margin-top: 0;
  padding-top: 0;
}
.form-create {
  &__add {
    width: 300px;
    margin: 20px 0;
  }
  &__chosen-check {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0;
  }

  &__chosen-check {
    position: relative;
    max-height: 100px; /* ограничение по высоте */
    overflow: hidden;
    margin-bottom: 10px;
  }

  &__chosen-check.blur::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 40px; /* высота области с блюром */
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.8) 100%
    );
    pointer-events: none;
  }

  &__chosen-check-item {
    padding: 5px;
    margin-right: 10px;
    margin-bottom: 10px;
    background: gainsboro;
    border-radius: 5px;
    display: flex;
    align-items: center;

    &.button {
      cursor: pointer;
      padding: 10px 20px;
      background: #3c2a1e;
      color: #fff;
      font-weight: 700;
    }
  }

  &__chosen-check-close {
    margin-left: 10px;
    cursor: pointer;
  }

  &__category-search {
    padding: 10px 20px;
    font-size: 16px;
  }
}
.input-select {
  max-width: 300px;
}
.checkbox-container {
  @include scrollBar;

  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 20px;

  &_margin {
    margin-top: 20px;
  }
}
.checkbox-container__item {
  padding: 5px 0;
}
.time {
  &__toggle-container {
    display: flex;
    padding: 10px 0;
  }

  &__toggle-item {
    padding: 10px 20px;
    background: gainsboro;
    border-radius: 10px;
    cursor: pointer;
    margin-right: 10px;

    &.active {
      background: #3c2a1e;
      color: #fff;
    }
  }

  &__item {
    padding: 20px 0;
  }

  &__item-day {
    display: flex;
    align-items: center;
  }

  &__item-day-name {
    width: 100px;
    font-weight: 700;
    text-transform: uppercase;
  }

  &__item-day-line {
    padding: 0 10px;
  }
}
.multi-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 20px;
  margin: 0 0 20px;
  border-bottom: 1px solid grey;

  &__text {
    font-size: 20px;
    font-weight: 700;
    width: 300px;
  }

  &__container {
    margin-right: auto;

    input {
      width: 400px;
    }
  }

  &__search {
    input {
      padding: 10px 15px;
    }
  }

  &__input {
    width: 100%;
    background: #e5e5e7;
    border-radius: 5px;
    height: 36px;
    border: none;
    outline: none;
    font-size: 16px;
    padding: 17px 0 16px 16px;
    border: 1px solid #cdcdce;
    box-sizing: border-box;
  }

  &__delete {
    margin-left: 30px;
  }
}

.fit {
  width: fit-content;
}
</style>
